import './App.css';
import './style.css';
import './widget.css'
import './frontend.css'
import './post.css'

import { ModalProvider } from './context/ModalContext';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

import AboutUsPage from './pages/AboutUsPage';
import ContactPage from './pages/ContactPage';
import { DNA } from 'react-loader-spinner';
import GamesPage from './pages/GamesPage';
import HomePage from './pages/HomePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import { ROUTES } from './Routes';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';

const AppContent = () => {
    function ScrollToTopOnRouteChange() {
        const location = useLocation();
        useEffect(() => {
            window.scrollTo(0, 0);
        }, [location.pathname]);
        return null;
    }

    return (
        <>
            <ScrollToTopOnRouteChange />
            <div className='js svg background-fixed'>
                <Routes>
                    <Route path={ROUTES.BASE} element={<HomePage />} />
                    <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicyPage />} />
                    <Route path={ROUTES.TERMS_AND_CONDITIONS} element={<TermsAndConditionsPage />} />
                    <Route path={ROUTES.ABOUT_US} element={<AboutUsPage />} />
                    <Route path={ROUTES.CONTACT} element={<ContactPage />} />
                    <Route path={ROUTES.GAMES} element={<GamesPage />} />
                </Routes>
            </div>
        </>
    );
};

const App = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <div style={{ margin: 0, padding: 0, height: '100%', overflow: 'hidden' }}>
                <DNA
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="dna-loading"
                    wrapperStyle={{ position: 'relative', top: 0, right: 0, height: '100vh', width: '100%', border: 'none' }}
                    wrapperClass="dna-wrapper"
                />
            </div>
        );
    }

    return (
        <Router>
            <ModalProvider>
                <AppContent />
            </ModalProvider>
        </Router>
    );
};

export default App;